export const TTI_SEVERITY_THRESHOLD_DEFAULTS = {
	NORMAL: 40000,
	DEGRADED: 60000,
};
